/**
 * @file: 渲染字码商品
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../../cubeTree/index';
import * as Toolkit from '../../../toolkit/index';
import RenderData, { SubGoodsRenderData } from './renderData';
import CreateSubGoodsDom from './createSubGoodsDom';
import { loadingImg } from './loadingImg';

export function renderSubGoods(cube: CubeNode): void {
    // 初始化操作
    initSubGoodsDom(cube);

    // 商品渲染
    renderGoods(cube);

    // 渲染完成后事务处理
    doMountedTask(cube);
}

// 初始化操作
function initSubGoodsDom(cube: CubeNode): void {
    let parentCube: CubeNode = CubeTree.findParentCubeByCubeId(cube.id);

    if (CubeTree.isBeam(parentCube.id)) {
        cube.jView.find('.g-sub').addClass('beam-sub');
    }
}

// 商品渲染
function renderGoods(cube: CubeNode): void {
    // 构建字码商品渲染数据
    let subGoodsRenderData: SubGoodsRenderData = RenderData.subGoods(cube);

    // 通过渲染数据构建字码商品渲染dom，带面宽、面高
    let $subGoods: JQuery = CreateSubGoodsDom(subGoodsRenderData);
    let $sub: JQuery<HTMLElement> = cube.jView.find('.J_Sub');

    Toolkit.html($sub, '');
    $sub.append($subGoods);
    loadingImg($sub);
}

// 渲染完成后事务处理
function doMountedTask(cube: CubeNode): void {
    let $subGoodsTag: JQuery<HTMLElement> = cube.jView.find('.hasSubList');
    let $subGoodsItem: JQuery<HTMLElement> = cube.jView.find('.sub-good-item');

    if ($subGoodsItem.length) {
        $subGoodsTag.addClass('sub-tag-show');
    }
    else {
        $subGoodsTag.removeClass('sub-tag-show');
    }
}
